import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { take } from 'rxjs/operators';

import { pendingPaymentQuery } from '@amfam/billing/pending-payment/data-access';
import { fromRouterActions } from '@amfam/shared/utility/navigation';

@Injectable()
export class BillAccountScheduledPaymentGuard {
  constructor(private store: Store) {}

  canActivate(): boolean {
    this.store
      .select(pendingPaymentQuery.selectPendingPayments)
      .pipe(take(1))
      .subscribe(pendingPayments => {
        if (!pendingPayments || pendingPayments.length === 0) {
          this.store.dispatch(
            fromRouterActions.Go({
              path: ['/billing']
            })
          );
          return false;
        }
      });
    return true;
  }
}
